import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles(
    (theme: Theme) => ({
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    }),
    { name: 'MuiDialogClose' },
);

export default useStyles;
